module.exports = __webpack_public_path__ + "img/flv.70be05e0.png";